import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl, HERO_IMG } from "../../lib/api";
import { useContent, pick } from "../../lib/content";
import { useSite } from "../../lib/site";
import { getBootstrap } from "../../lib/bootstrap";
import { cache } from "../../lib/cache";
import SEO from "../../components/SEO";
import CTABand from "../../components/public/CTABand";

export default function Blog() {
  const c = useContent();
  const site = useSite();
  const [posts, setPosts] = useState(() => {
    const boot = getBootstrap("blog");
    if (Array.isArray(boot) && boot.length > 0) return boot;
    const cached = cache.get("blog");
    if (Array.isArray(cached)) return cached;
    return [];
  });
  useEffect(() => {
    let cancelled = false;
    api.get("/blog").then((r) => {
      if (cancelled) return;
      if (Array.isArray(r.data)) {
        cache.set("blog", r.data);
        setPosts(r.data);
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="blog-page">
      <SEO
        path="/blog"
        title="Journal — Project Notes & Build Logs"
        description="Build logs, material deep-dives, and behind-the-scenes from ATC Home Pro's job sites."
      />
      <section className="bg-atc-black text-white pt-20 pb-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-blueprint-grid-dark bg-[size:4rem_4rem] opacity-30" />
        <div className="container-max relative">
          <div className="overline mb-4 text-atc-red">{pick(c, "blog_page.hero_overline", "Journal")}</div>
          <h1 className="h-display">{pick(c, "blog_page.hero_title_line_1", "Project notes")}<br/>{pick(c, "blog_page.hero_title_line_2", "from the field.")}</h1>
          <p className="mt-6 text-white/80 text-lg max-w-2xl">{pick(c, "blog_page.hero_body", "")}</p>
        </div>
      </section>

      <section className="section-pad bg-atc-paper">
        <div className="container-max">
          {posts.length === 0 ? (
            <div className="text-center py-20 border-2 border-dashed border-atc-black/30" data-testid="blog-empty">
              <p className="text-atc-muted">{pick(c, "blog_page.empty_message", "No posts yet — check back soon.")}</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((p) => (
                <Link
                  key={p.id}
                  to={`/blog/${p.slug}`}
                  className="group block border-2 border-atc-black bg-white transition-all duration-200 hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#1A1A1A]"
                  data-testid={`blog-card-${p.slug}`}
                >
                  <div className="aspect-[16/10] overflow-hidden bg-atc-black">
                    <img src={fileUrl(p.cover_image) || HERO_IMG} alt={p.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition duration-500" />
                  </div>
                  <div className="p-6">
                    <div className="overline mb-2">{new Date(p.created_at).toLocaleDateString()}</div>
                    <h3 className="h-card group-hover:text-atc-red">{p.title}</h3>
                    {p.excerpt && <p className="mt-3 text-sm text-atc-muted line-clamp-3">{p.excerpt}</p>}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTABand phone={site?.phone} />
    </div>
  );
}
